import { redux_store } from "../../../store";
import { API } from "../../api";
async function redeem_voucher(data) {
    const state = redux_store.getState();
    const { user } = state.userState;
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/redeem/voucher`, //
        content: data,
        authorization: user.token,
    });
}
export { redeem_voucher };
